<template>
  <div class="chart">
    <canvas ref="chart" :width="this.width" :height="this.height"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    currency: {
      type: Boolean,
      default () {
        false
      }
    },
    scales: {
      type: Object,
      default () {
        return {
          yAxes: [],
          xAxes: []
        }
      }
    },
    datasets: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default () {
        return 'bar'
      }
    },
    height: {
      type: Number,
      default () {
        return 400
      }
    },
    width: {
      type: Number,
      default () {
        return 400
      }
    }
  },
  data () {
    return {
      chart: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return '$' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
      }
    }
  },
  mounted () {
    if (!this.currency) this.callbacks = {}
    this.chart = new Chart(this.$refs.chart, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        },
        tooltips: {
          mode: 'label',
          callbacks: this.callbacks
        },
        scales: this.scales
      }
    })
  },
  methods: {
    async refresh () {
      if (this.datasets.length > 0 && this.datasets[0].data.length > 0) {
        this.chart.data.datasets = this.datasets
        this.chart.data.labels = this.labels
        await this.$nextTick()
        this.chart.update(1000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/Chart.vue